<template>
    <footer class="bg-gray-800 text-white py-12">
        <div class="max-w-7xl mx-auto px-4">
            <div class="grid grid-cols-4 gap-8">
                <div>
                    <h3 class="text-lg font-bold mb-4">关于我们</h3>
                    <p class="text-gray-400">疏心小站致力于为个人和企业提供专业的心理健康服务，让每个人都能获得内心的平静与力量。</p>
                </div>
                <div>
                    <h3 class="text-lg font-bold mb-4">联系方式</h3>
                    <p class="text-gray-400">电话：400-888-9999</p>
                    <p class="text-gray-400">邮箱：contact@suxin.com</p>
                </div>
                <div>
                    <h3 class="text-lg font-bold mb-4">服务时间</h3>
                    <p class="text-gray-400">周一至周日</p>
                    <p class="text-gray-400">9:00 - 21:00</p>
                </div>
                <div>
                    <h3 class="text-lg font-bold mb-4">关注我们</h3>
                    <div class="flex space-x-4">
                        <i class="fab fa-weixin text-2xl cursor-pointer hover:text-blue-400"></i>
                        <i class="fab fa-weibo text-2xl cursor-pointer hover:text-blue-400"></i>
                    </div>
                </div>
            </div>
            <div class="mt-8 pt-8 border-t border-gray-700 text-center text-gray-400">
                <p>© 2024 疏心小站 版权所有</p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'SiteFooter'
}
</script>